"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  name: "Νίκος Α.",
  location: "CEO, Tech Solutions",
  quote: <>
        Η <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/logo.png" alt="Ds-Services" className="h-7 inline-block align-middle" /> αναβάθμισε πλήρως το δίκτυο του γραφείου μας. Η ταχύτητα και η ασφάλεια των δεδομένων μας είναι πλέον σε κορυφαίο επίπεδο. Επαγγελματισμός και τεχνική κατάρτιση που σπανίζει.
      </>,
  rating: 5,
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/avatar_george_p.png"
}, {
  id: 2,
  name: "Σοφία Λ.",
  location: "Διευθύντρια, Law Firm",
  quote: "Η εγκατάσταση των συστημάτων ελέγχου πρόσβασης και των καμερών έγινε με απόλυτη ακρίβεια. Νιώθουμε σιγουριά για την ασφάλεια του χώρου μας 24/7. Η υποστήριξη είναι άμεση.",
  rating: 5,
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/avatar_maria_k.png"
}, {
  id: 3,
  name: "Δημήτρης Κ.",
  location: "IT Manager, Logistics",
  quote: "Εξαιρετική δουλειά στη μετάβαση των email μας και στη ρύθμιση των server. Δεν είχαμε ούτε ένα λεπτό downtime. Πραγματικοί συνεργάτες που κατανοούν τις ανάγκες μιας σύγχρονης επιχείρησης.",
  rating: 5,
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/avatar_kostas_n.png"
}, {
  id: 4,
  name: "Κατερίνα Μ.",
  location: "Owner, Creative Agency",
  quote: <>
        Από την κατασκευή της ιστοσελίδας μας μέχρι τα συστήματα συναγερμού, η <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/logo.png" alt="Ds-Services" className="h-7 inline-block align-middle" /> προσφέρει ολοκληρωμένες λύσεις. Η προσοχή στη λεπτομέρεια και ο μοντέρνος εξοπλισμός τους ξεχωρίζουν.
      </>,
  rating: 5,
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/avatar_eleni_s.png"
}];
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="123419" id="εμπειρίες-πελατών-μας" className="py-24 bg-[#020617] relative overflow-hidden dark">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[60%] h-[60%] rounded-full bg-[#06B6D4]/10 blur-[120px]" />
        <div className="absolute bottom-[10%] -left-[10%] w-[50%] h-[50%] rounded-full bg-[#6366F1]/10 blur-[100px]" />
        
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_10%,transparent_100%)] opacity-20" />
      </div>

      <div ref={ref} className={`container mx-auto px-4 relative z-10 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-xs font-mono font-bold tracking-[0.2em] text-[#06B6D4] uppercase mb-3">
            ΑΞΙΟΛΟΓΗΣΕΙΣ ΣΥΣΤΗΜΑΤΩΝ
          </h2>
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 tracking-tighter">
            Εμπειρίες Πελατών μας
          </h3>
          <p className="text-slate-400 text-lg md:text-xl leading-relaxed">
            Η ασφάλεια και η αποδοτικότητα της ψηφιακής σας υποδομής είναι η μεγαλύτερη δέσμευσή μας. Δείτε τι λένε οι επαγγελματίες που μας εμπιστεύονται.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full max-w-7xl mx-auto">
          <CarouselContent className="-ml-4 md:-ml-6 py-4">
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                <Card className="h-full bg-[#0F172A]/40 backdrop-blur-xl border-white/5 shadow-2xl hover:shadow-[0_0_30px_rgba(6,182,212,0.15)] hover:border-[#06B6D4]/30 transition-all duration-500 flex flex-col relative overflow-hidden group">
                  {}
                  <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(6,182,212,0.05)_0%,transparent_70%)] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#06B6D4] to-[#6366F1] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  
                  <CardHeader className="pb-4 relative z-10">
                    <div className="flex justify-between items-start">
                      <div className="flex gap-1">
                        {[...Array(testimonial.rating)].map((_, j) => <Star key={j} className="w-4 h-4 fill-[#06B6D4] text-[#06B6D4]" />)}
                      </div>
                      <Quote className="w-10 h-10 text-[#06B6D4]/10 group-hover:text-[#06B6D4]/20 transition-colors duration-500 transform -scale-x-100" />
                    </div>
                  </CardHeader>
                  
                  <CardContent className="flex-grow relative z-10">
                    <p className="text-slate-200 leading-relaxed text-lg md:text-xl font-medium italic">
                      "{testimonial.quote}"
                    </p>
                  </CardContent>
                  
                  <CardFooter className="pt-6 border-t border-white/5 relative z-10">
                    <div className="flex items-center gap-4">
                      <SafeHydrate><Avatar className="w-14 h-14 border-2 border-[#020617] shadow-xl ring-2 ring-[#06B6D4]/20">
                        <AvatarImage src={testimonial.avatarUrl} alt={testimonial.name} className="object-cover grayscale group-hover:grayscale-0 transition-all duration-500" />
                        <AvatarFallback className="bg-[#1e293b] text-[#06B6D4] font-bold text-lg">
                          {testimonial.name.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="flex flex-col">
                        <span className="font-bold text-[#06B6D4] text-base tracking-tight">
                          {testimonial.name}
                        </span>
                        <span className="text-xs font-mono text-slate-500 flex items-center gap-1 uppercase">
                          <span className="w-1.5 h-1.5 rounded-none bg-[#6366F1] inline-block shadow-[0_0_5px_#6366F1]" />
                          {testimonial.location}
                        </span>
                      </div>
                    </div>
                  </CardFooter>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          
          {}
          <div className="flex justify-center items-center gap-4 mt-12">
            <CarouselPrevious className="static translate-y-0 translate-x-0 w-12 h-12 rounded-sm border-white/10 bg-[#0F172A]/80 backdrop-blur-md text-white hover:bg-[#06B6D4] hover:text-[#020617] hover:border-[#06B6D4] transition-all duration-300 shadow-xl" />
            <CarouselNext className="static translate-y-0 translate-x-0 w-12 h-12 rounded-sm border-white/10 bg-[#0F172A]/80 backdrop-blur-md text-white hover:bg-[#06B6D4] hover:text-[#020617] hover:border-[#06B6D4] transition-all duration-300 shadow-xl" />
          </div>
        </Carousel>
      </div>
    </section>;
}